import { Box, Flex } from '@chakra-ui/react'
import { memo, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { generateSessionId, redirectToNewPage } from '../../global/helpers/global-helpers'
import DsrHeader from '../components/DsrHeader'
import RenderStaticDsrContent from '../components/RenderStaticDsrContent'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'


const DsrViewArchivedPage = ({
  dsrInvalidRequestRedux,
  dsrConfiguration,
  dsrFeedContent,
  getDsrFeedContent,
  selectedDisplaySubpage,
  dsrTeamMembersRedux,
  dsrTitleRedux,
  fetchInitialDsrData,
  resetDsrFeedContent,
  resetDsrSelectedDisplaySubpage,
  resetDsrPages,
  updateDsrReset,
  dsrUserTeam,
  isArchivedDsr,
  isShrunkHeader,
}) => {

  const { dsrId } = useParams()
  const history = useHistory();
  const initRef = useRef(false);

  const [isSellingTeamMember, setIsSellingTeamMember] = useState(null)
  const [sessionId, setSessionId] = useState(null)

  const isMobileView = window.screen.width < 770;
  const headerMenuHeight = isShrunkHeader ? '120px' : isMobileView ? '170px' : '140px'

  // Page Setup
  useEffect(() => {
    if (!initRef.current && dsrId !== 'new') {
      document.title = 'Launchdeck Digital Sales Room'
      document.description =
        'Create customised private digital sales rooms that let Sales & Purchasing teams agree on deals quickly'

      fetchInitialDsrData({
        dsrId,
        dsrStatuses: ['archived'],
        isLiveEdit: false,
        isViewArchived: true
      })

      const generatedSessionId = generateSessionId()
      setSessionId(generatedSessionId)


      initRef.current = true
    }
  }, [dsrId, fetchInitialDsrData])


  // Business Logic
  useEffect(() => {
    if (dsrInvalidRequestRedux === true) {
      history.push(`/invalid`, {
        redirectionUri: `/home`
      })
    }

    // TODO: Redirect users if it is NOT an active status DSR. 
    // However there is a UX issue if user goes to draft DSR first, and then Vault, and then active DSR, there is a temp state where it is still 'draft' status, and user will be redirected to invalid page

    if (dsrConfiguration) {
      const { status } = dsrConfiguration || {}
      if (status !== 'archived') {
        redirectToNewPage('/invalid') // TODO use react router
      }
    }

  }, [dsrConfiguration, dsrId, dsrInvalidRequestRedux])

  useEffect(() => {
    if (selectedDisplaySubpage === 'updates-subpage') getDsrFeedContent(dsrId)
  }, [dsrId, getDsrFeedContent, selectedDisplaySubpage])

  useEffect(() => {
    if (dsrUserTeam) {
      const isSellerMember = (dsrUserTeam === "host") ? true : false;
      setIsSellingTeamMember(isSellerMember)
    }

  }, [setIsSellingTeamMember, dsrUserTeam])

  useEffect(() => {
    return () => resetDsrFeedContent() && resetDsrSelectedDisplaySubpage() && resetDsrPages() && updateDsrReset()
  }, [resetDsrFeedContent, resetDsrSelectedDisplaySubpage, resetDsrPages, updateDsrReset])

  return (
    <Flex direction="column" >
      <Flex direction="row" flexGrow="1">
        <Flex w="100%" direction="column" alignItems="center" bg="white">
          <Box width='100%' position='fixed' top='0' zIndex='2'>
            <DsrHeader
              dsrTeamMembers={dsrTeamMembersRedux}
              dsrTitle={dsrTitleRedux}
              isSellingTeamMember={isSellingTeamMember}
              dsrId={dsrId}
              isArchivedDsr={isArchivedDsr}
            />
          </Box>
          <Flex w="100%" className="authentication-container"
            transition="padding 0.3s ease-in-out"
            justify="center" pt={headerMenuHeight} bg={'#F4F4F4'}>
            <RenderStaticDsrContent
              dsrId={dsrId}
              sessionId={sessionId}
              dsrConfiguration={dsrConfiguration}
              dsrFeedContent={dsrFeedContent}
              isArchivedDsr={true}
            />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default memo(DsrViewArchivedPage)
